import React from 'react';
import styles from './style.module.scss';
import logoDefault from './assets/logoDefault.svg';
import logoBhvk from './assets/logoBhvk.svg';

interface HeaderLogoProps {
  isBhvkLogo: boolean;
}

const HeaderLogo: React.FC<HeaderLogoProps> = ({ isBhvkLogo }) => {

  return (
    <div className={styles['logo-container']}>
      {isBhvkLogo ? <img src={logoBhvk} alt="BHV-Knop.nl Logo" className={styles.logo}/>
        : <img src={logoDefault} alt="X-Guard Logo" className={styles.logo}/>}
    </div>
  );

};

export default HeaderLogo;
